<template>
	<div>
		<div id="app">
			<div class="app-container">
				<!-- 头部 -->
				<el-card class="header-card" shadow="never">
					<div class="header-title">LPA 活动配置管理</div>
					<div class="header-desc">按年份管理 LPA 评选活动的各项参数</div>
				</el-card>

				<!-- 年份 Tab 栏 -->
				<el-card class="config-card" shadow="never">
					<div slot="header">
						<h3>年份配置列表</h3>
					</div>
					<div>
						<el-tag v-for="year in yearList" :key="year" :type="activeYear === year ? 'primary' : 'info'"
							effect="plain" class="year-tag" size="medium" @click="switchYear(year)" closable
							@close="removeYear(year)">
							{{ year }}
						</el-tag>
						<el-button type="primary" plain size="small" icon="el-icon-plus"
							@click="addYear">添加年份</el-button>
					</div>
				</el-card>

				<!-- 当前年份配置表单 -->
				<div v-if="!loading && activeYear && currentData">
					<!-- 投票设置 -->
					<el-card class="config-card" shadow="never">
						<div slot="header">
							<h3>{{ activeYear }}年 - 投票设置</h3>
						</div>
						<el-form ref="formData" label-position="top">
							<el-row :gutter="20">
								<el-col :span="12">
									<el-form-item label="投票数上限">
										<el-input-number v-model="currentData.voteNum" :min="1" :max="100"
											size="small" style="width: 80%;"></el-input-number>
										<div class="form-item-tip">LiveHouse 分类每用户可投票数上限</div>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="音乐节投票数上限">
										<el-input-number v-model="currentData.musicVoteNum" :min="1" :max="100"
											size="small" style="width: 80%;"></el-input-number>
										<div class="form-item-tip">音乐节分类每用户可投票数上限</div>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<el-form-item label="票夹活动开始时间" required>
										<el-date-picker v-model="currentData.actStart" type="datetime" placeholder="选择开始时间"
										                value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-dd HH:mm:ss" size="small" style="width:80%">
										            </el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="票夹活动结束时间" required>
										<el-date-picker v-model="currentData.actEnd" type="datetime" placeholder="选择结束时间"
										                value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-dd HH:mm:ss" size="small" style="width:80%">
										            </el-date-picker>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<el-form-item label="榜单展示开始时间" required>
										<el-date-picker v-model="currentData.suduStartTime" type="datetime" placeholder="选择开始时间"
										                value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-dd HH:mm:ss" size="small" style="width:80%">
										            </el-date-picker>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="榜单展示结束时间" required>
										<el-date-picker v-model="currentData.suduEndTime" type="datetime" placeholder="选择结束时间"
										                value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-dd HH:mm:ss" size="small" style="width:80%">
										            </el-date-picker>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="12">
									<el-form-item label="订单详情/票夹详情LPA入口占位图" required prop="entrancePic" >
										<image-upload
										    :url.sync="currentData.entrancePic" 
										    :urlFull.sync="currentData.entrancePic" 
										>
										</image-upload>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="限制ID"  prop="hideIds" >
										<el-input placeholder="请填写限制ID" v-model="currentData.hideIds"  style="width:80%">
										</el-input>
										<div class="form-item-tip">多个ID之间用逗号分隔</div>
									</el-form-item>
								</el-col>
							</el-row>
						</el-form>
					</el-card>

					<!-- 分类排序 - 整行拖拽 -->
					<el-card class="config-card" shadow="never">
						<div slot="header">
							<h3>{{ activeYear }}年 - 分类排序 <span
									style="font-size:12px; font-weight:normal; color:#999;">入围阶段无效</span></h3>
						</div>
						<div class="type-sort-container">							
							<vuedraggable v-model="currentData.typeSort" :options="{ animation: 150 }" @end="onSortEnd">
										<div v-for="(item, index) in currentData.typeSort" :key="item.typeId"
											class="sortable-item">
											<div style="display:flex; align-items:center; width:40%; cursor:grab;">		
												<span class="sort-index"><span class="el-icon-sort"></span>{{ index + 1 }}</span>
												<span class="sort-label">{{ item.typeId }} - {{ typeOptions[item.typeId] }}</span>
												<span v-if="item.pic1" style="margin-left: 10px;">
													<el-image :src="item.pic1 | coverImage(80,80)" fit="cover" :preview-src-list="[item.pic1]"></el-image>
												</span>
												<span v-if="item.pic2" style="margin-left: 5px;">
													<el-image :src="item.pic2 | coverImage(80,80)" fit="cover" :preview-src-list="[item.pic2]"></el-image>
												</span>
												<span v-if="item.pic3" style="margin-left: 5px;">
													<el-image :src="item.pic3 | coverImage(80,80)" fit="cover" :preview-src-list="[item.pic3]"></el-image>
												</span>
											</div>
											<div>
												<el-button
													type="text"
													size="small"
													icon="el-icon-upload2"
													@click="uploadPic(currentData.typeSort,typeOptions[item.typeId], index)"
													>上传图片</el-button
												>										
											</div>
										</div>
									</vuedraggable>
						</div>
					</el-card>

					<!-- 阶段配置 -->
					<el-card class="config-card" shadow="never">
						<div slot="header">
							<h3>{{ activeYear }}年 - 阶段配置<span
									style="font-size:12px; font-weight:normal; color:#999;"> 固定三个阶段</span></h3>
						</div>
						<div v-for="(step, stepIdx) in currentData.steps" :key="step.key" class="step-card">
							<div class="step-header">
								<div>
									<span
										:class="['step-badge', stepBadgeClass(stepIdx)]">{{ stepBadgeName(stepIdx) }}</span>
									<span style="margin-left:12px; font-weight:500;">key = {{ step.key }}</span>
								</div>
							</div>
							<el-form label-width="auto" size="small">
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label="阶段名称">
											<el-input v-model="step.name" size="small" style="width: 80%;"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="排序方式">
											<el-select v-model="step.sortType" size="small" style="width:80%">
												<el-option label="票数倒序" :value="1"></el-option>
												<el-option label="随机" :value="2"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label="阶段开始时间" required>
											<el-date-picker v-model="step.startTime" type="datetime" placeholder="选择开始时间"
												value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-dd HH:mm:ss"
												size="small" style="width:80%">
											</el-date-picker>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="阶段结束时间" required>
											<el-date-picker v-model="step.endTime" type="datetime" placeholder="选择结束时间"
												value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-dd HH:mm:ss"
												size="small" style="width:80%">
											</el-date-picker>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>

							<!-- <el-divider content-position="left">每行数量配置</el-divider>
							<div v-for="(val, key, idx) in step.lineNumMap" :key="'line_'+key" class="map-row">
								<el-select v-model="step.lineNumMapKeys[idx]" size="small" placeholder="请选择分类"
									@change="updateMapKey(step, 'lineNumMap', idx, $event)">
									<el-option v-for="(optName, optId) in typeOptions" :key="optId"
										:label="optId + ' - ' + optName" :value="optId">
									</el-option>
								</el-select>
								<el-input-number v-model="step.lineNumMap[step.lineNumMapKeys[idx]]" :min="1"
									size="small"></el-input-number>
								<i class="el-icon-delete del-btn" @click="removeMapEntry(step, 'lineNumMap', key)"></i>
							</div>
							<el-button 
								v-if="shouldShowAddButton(step, 'lineNumMap')"
								type="text" size="small" icon="el-icon-plus"
								@click="addMapEntry(step, 'lineNumMap')">添加</el-button> -->

							<el-divider content-position="left">获奖数量配置</el-divider>
							<div v-for="(val, key, idx) in step.winNumMap" :key="'win_'+key" class="map-row">
								<el-select v-model="step.winNumMapKeys[idx]" size="small" placeholder="请选择分类"
									@change="updateMapKey(step, 'winNumMap', idx, $event)">
									<el-option v-for="(optName, optId) in typeOptions" :key="optId"
										:label="optId + ' - ' + optName" :value="optId">
									</el-option>
								</el-select>
								<el-input-number v-model="step.winNumMap[step.winNumMapKeys[idx]]" :min="1"
									size="small"></el-input-number>
								<i class="el-icon-delete del-btn" @click="removeMapEntry(step, 'winNumMap', key)"></i>
							</div>
							<el-button 
								v-if="shouldShowAddButton(step, 'winNumMap')"
								type="text" size="small" icon="el-icon-plus"
								@click="addMapEntry(step, 'winNumMap')">添加</el-button>
						</div>
					</el-card>
				</div>

				<div v-else-if="!loading && (!activeYear || !currentData)" class="empty-tip">
					<i class="el-icon-info" style="font-size:48px; color:#c0c4cc;"></i>
					<p style="margin-top:12px;">请先添加一个年份配置</p>
				</div>

				<div v-if="loading" class="empty-tip">
					<i class="el-icon-loading" style="font-size:48px; color:#667eea;"></i>
					<p style="margin-top:12px;">加载配置中...</p>
				</div>

				<div class="action-buttons">
					<el-button size="medium" type="primary" @click="submitConfig" :loading="btnLoading"
						icon="el-icon-s-operation">提交配置</el-button>
				</div>
			</div>
		</div>
		<pic ref="Pic"></pic>
	</div>
</template>

<script>
	import vuedraggable from 'vuedraggable';
	import Pic from  './components/pic.vue'
	import ImageUpload from '@/components/ImageUpload';
	// 常量定义
	const TYPE_OPTIONS = {
		'2': '最佳现场', '3': '最具潜力', '4': '最佳场地', '5': '最佳厂牌',
		'6': '最佳体验音乐节', '7': '最具人气', '8': '年度音乐人', '9': '特殊贡献'
	};
	const STEP_DEFAULTS = [
		{ key: 1, name: '投票阶段', badge: 'step-badge-1' },
		{ key: 2, name: '入围阶段', badge: 'step-badge-2' },
		{ key: 3, name: '获奖阶段', badge: 'step-badge-3' }
	];
	
	// 所有可用分类ID列表
	const ALL_TYPE_IDS = ['2', '3', '4', '5', '6', '7', '8', '9'];
	
	export default {
		components: { vuedraggable,Pic,ImageUpload},
		data() {
			return {
				yearList: [],
				activeYear: null,
				yearData: {},
				typeOptions: TYPE_OPTIONS,
				btnLoading: false,
				loading: false
			}
		},
		computed: {
			currentData: {
				get() {
					if (!this.activeYear || !this.yearData[this.activeYear]) return null;
					return this.yearData[this.activeYear];
				},
				set(val) {
					if (this.activeYear) this.$set(this.yearData, this.activeYear, val);
				}
			}
		},
		created() {
			this.initDefaultData();
		},
		methods: {
			uploadPic(data,name,index) {
			    this.$refs.Pic.show(data,name,index);
			},
			// 判断是否显示添加按钮
			shouldShowAddButton(step, mapName) {
				const map = step[mapName];
				const currentCount = Object.keys(map || {}).length;
				
				// 获奖阶段（key=3）不显示添加按钮
				if (step.key === 3) {
					return false;
				}
				
				// 投票阶段（key=1）最多8个分类
				if (step.key === 1) {
					return currentCount < ALL_TYPE_IDS.length;
				}
				
				// 入围阶段（key=2）最多8个分类
				if (step.key === 2) {
					return currentCount < ALL_TYPE_IDS.length;
				}
				
				return false;
			},
			
			
			localToDateTimeStr(localStr) {
			    if (!localStr) return '';
			    return localStr.replace('T', ' ');
			},
			
			
			dateTimeToLocal(str) {
			    if (!str) return '';
			    return str.replace(' ', 'T');
			},
			
			createDefaultYearData() {
				return {
					voteNum: 0,
					musicVoteNum: 0,
					hideIds:'',
					typeSort: ['2', '3', '5', '4', '6', '7', '8', '9'].map(item => ({ 
						typeId: item, 
						pic1: '', 
						pic2: '', 
						pic3: '' 
					})),
					actStart: '',
					actEnd: '',
					suduStartTime:'',
					suduEndTime:'',
					steps: [
						{
							key: 1,
							name: '投票阶段',
							startTime: '',
							endTime: '',
							sortType: 1,
							lineNumMap: { '2': 1, '4': 1, '5': 1, '6': 1 },
							winNumMap: {},
							lineNumMapKeys: ['2', '4', '5', '6'],
							winNumMapKeys: []
						},
						{
							key: 2,
							name: '入围阶段',
							startTime: '',
							endTime: '',
							sortType: 2,
							lineNumMap: { '2': 1, '3': 1, '4': 1, '5': 1, '6': 1, '7': 1 },
							winNumMap: { '2': 1, '3': 1, '4': 1, '5': 1, '6': 1, '7': 1 },
							lineNumMapKeys: ['2', '3', '4', '5', '6', '7'],
							winNumMapKeys: ['2', '3', '4', '5', '6', '7']
						},
						{
							key: 3,
							name: '获奖阶段',
							startTime: '',
							endTime: '',
							sortType: 1,
							lineNumMap: { '2': 1, '3': 1, '4': 1, '5': 1, '6': 1, '7': 1, '8': 1, '9': 1 },
							winNumMap: { '2': 1, '3': 1, '4': 1, '5': 1, '6': 1, '7': 1, '8': 1, '9': 1 },
							lineNumMapKeys: ['2', '3', '4', '5', '6', '7', '8', '9'],
							winNumMapKeys: ['2', '3', '4', '5', '6', '7', '8', '9']
						}
					]
				};
			},
			
			ensureStepKeys(step) {
				if (!step.lineNumMapKeys) step.lineNumMapKeys = Object.keys(step.lineNumMap || {});
				if (!step.winNumMapKeys) step.winNumMapKeys = Object.keys(step.winNumMap || {});
			},
			
			// 将接口返回的数据转换为页面数据格式
			parseApiDataToPageData(apiData) {
				const pageData = {};
				const configMap = apiData.configMap || apiData;
				for (const [yr, yrCfg] of Object.entries(configMap)) {
					// 处理 typeSort：保留完整的对象数组
					let typeSortData = [];
					if (yrCfg.typeSort && yrCfg.typeSort.length > 0) {
						if (typeof yrCfg.typeSort[0] === 'object' && yrCfg.typeSort[0].hasOwnProperty('typeId')) {
							// 保留完整的对象数据，但确保 typeId 转为字符串以便匹配
							typeSortData = yrCfg.typeSort.map(item => ({
								typeId: String(item.typeId),
								pic1: item.pic1 || '',
								pic2: item.pic2 || '',
								pic3: item.pic3 || ''
							}));
						} else {
							// 兼容旧格式
							typeSortData = yrCfg.typeSort.map(item => ({ 
								typeId: String(item), 
								pic1: '', 
								pic2: '', 
								pic3: '' 
							}));
						}
					} else {
						typeSortData = ['2', '3', '5', '4', '6', '7', '8', '9'].map(item => ({ 
							typeId: item, 
							pic1: '', 
							pic2: '', 
							pic3: '' 
						}));
					}
					
					const steps = (yrCfg.stepConfig || []).map(s => {
						const lineNumMap = s.lineNumMap || {};
						const winNumMap = s.winNumMap || {};
						
						return {
							key: s.key,
							name: s.name || '',
							startTime: s.startTime ? this.dateTimeToLocal(s.startTime) : '',
							endTime: s.endTime ? this.dateTimeToLocal(s.endTime) : '',
							sortType: s.sortType !== undefined ? s.sortType : (s.key === 2 ? 2 : 1),
							lineNumMap: lineNumMap,
							winNumMap: winNumMap,
							lineNumMapKeys: Object.keys(lineNumMap),
							winNumMapKeys: Object.keys(winNumMap)
						};
					});
					
					while (steps.length < 3) {
						const missingKey = steps.length + 1;
						const defaultStep = STEP_DEFAULTS.find(d => d.key === missingKey);
						steps.push({
							key: missingKey,
							name: defaultStep?.name || '',
							startTime: '',
							endTime: '',
							sortType: missingKey === 2 ? 2 : 1,
							lineNumMap: {},
							winNumMap: {},
							lineNumMapKeys: [],
							winNumMapKeys: []
						});
					}
					
					pageData[yr] = {
						voteNum: yrCfg.voteNum || 1,
						musicVoteNum: yrCfg.musicVoteNum || 1,
						actStart: yrCfg.actStart ? this.dateTimeToLocal(yrCfg.actStart) : '',
						actEnd: yrCfg.actEnd ? this.dateTimeToLocal(yrCfg.actEnd) : '',
						suduStartTime: yrCfg.suduStartTime ? this.dateTimeToLocal(yrCfg.suduStartTime) : '',
						suduEndTime: yrCfg.suduEndTime ? this.dateTimeToLocal(yrCfg.suduEndTime) : '',
						entrancePic:yrCfg.entrancePic || '',
						hideIds:yrCfg.hideIds || '',
						typeSort: typeSortData,
						steps: steps
					};
				}
				return pageData;
			},
			// 加载默认配置
			loadDefaultConfig() {
				this.yearList = ['2026'];
				const defaultData = this.createDefaultYearData();
				this.$set(this.yearData, '2026', defaultData);
				this.activeYear = '2026';
				if (this.yearData['2026'] && this.yearData['2026'].steps) {
					this.yearData['2026'].steps.forEach(step => this.ensureStepKeys(step));
				}
			},
			
			// 初始化数据（请求接口获取配置）
			
			initDefaultData() {
				this.loading = true;
				this.$request({
					url: '/lpa/config',
					method: 'POST'
				})
				.then((res) => {
					const { state, result, data } = res.data;
					
					
					// 获取配置数据 - 优先从 result.configMap 获取
					let configMap = null;
					if (result && result.configMap) {
						configMap = result.configMap;
						
					} else if (data && data.configMap) {
						configMap = data.configMap;
						
					} else if (data && data.config && data.config.configMap) {
						configMap = data.config.configMap;
						
					}
					
					if (state == 1 && configMap && Object.keys(configMap).length > 0) {
						// 有数据，解析并回显
						const parsedData = this.parseApiDataToPageData({ configMap });
						
						
						this.yearList = Object.keys(parsedData);
						this.yearData = parsedData;
						this.activeYear = this.yearList.length > 0 ? this.yearList[0] : null;
						if (this.activeYear && this.yearData[this.activeYear] && this.yearData[this.activeYear].steps) {
							this.yearData[this.activeYear].steps.forEach(step => this.ensureStepKeys(step));
						}
						//this.$message.success('配置加载成功');
					} else {
						
						this.loadDefaultConfig();
					}
				})
				.catch((err) => {
					console.error('请求失败：', err);
					
					this.loadDefaultConfig();
				})
				.finally(() => {
					this.loading = false;
				});
			},
			
			addYear() {
				this.$prompt('请输入配置key，一般以年份命名（如 2026）', '添加年份', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^\d{4}$/,
					inputErrorMessage: '请输入4位数字年份'
				}).then(({ value }) => {
					if (this.yearList.includes(value)) {
						this.$message.error('该年份已存在');
						return;
					}
					this.yearList.push(value);
					const newData = this.createDefaultYearData();
					this.$set(this.yearData, value, newData);
					this.switchYear(value);
					this.$message.success(`已添加 ${value} 年配置`);
				}).catch(() => {});
			},
			
			removeYear(year) {
				this.$confirm(`确定要删除 ${year} 年的配置吗？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const idx = this.yearList.indexOf(year);
					this.yearList.splice(idx, 1);
					this.$delete(this.yearData, year);
					if (this.activeYear === year) {
						this.activeYear = this.yearList.length > 0 ? this.yearList[0] : null;
					}
					this.$message.success(`已删除 ${year} 年配置`);
				}).catch(() => {});
			},
			
			switchYear(year) {
				this.activeYear = year;
				if (this.yearData[year] && this.yearData[year].steps) {
					this.yearData[year].steps.forEach(step => this.ensureStepKeys(step));
				}
				// 强制刷新视图
				this.$forceUpdate();
			},
			
			onSortEnd() {
				this.$forceUpdate();
			},
			
			stepBadgeClass(stepIdx) {
				return STEP_DEFAULTS[stepIdx]?.badge || '';
			},
			
			stepBadgeName(stepIdx) {
				return STEP_DEFAULTS[stepIdx]?.name || '';
			},
			
			addMapEntry(step, mapName) {
				const keysArrName = mapName + 'Keys';
				if (!step[keysArrName]) step[keysArrName] = [];
				
				const usedKeys = step[keysArrName] || [];
				let newKey = '';
				for (let i = 0; i < ALL_TYPE_IDS.length; i++) {
					if (!usedKeys.includes(ALL_TYPE_IDS[i])) {
						newKey = ALL_TYPE_IDS[i];
						break;
					}
				}
				
				if (!newKey) {
					this.$message.warning('所有分类已添加完毕');
					return;
				}
				
				this.$set(step[mapName], newKey, 1);
				step[keysArrName].push(newKey);
				this.$forceUpdate();
			},
			
			removeMapEntry(step, mapName, key) {
				const keysArrName = mapName + 'Keys';
				const idx = step[keysArrName].indexOf(key);
				if (idx !== -1) step[keysArrName].splice(idx, 1);
				this.$delete(step[mapName], key);
				this.$forceUpdate();
			},
			
			updateMapKey(step, mapName, idx, newKey) {
				const oldKey = step[mapName + 'Keys'][idx];
				if (!newKey || oldKey === newKey) return;
				if (step[mapName].hasOwnProperty(newKey) && newKey !== oldKey) {
					this.$message.warning('该分类已存在，不能重复添加');
					return;
				}
				const value = step[mapName][oldKey];
				this.$delete(step[mapName], oldKey);
				this.$set(step[mapName], newKey, value);
				step[mapName + 'Keys'][idx] = newKey;
				this.$forceUpdate();
			},
			
			// 构建提交数据
			buildSubmitData() {
				const configMap = {};
				for (let yr of this.yearList) {
					const d = this.yearData[yr];
					if (!d) continue;
					
					// 转换 typeSort 为完整的对象数组
					const typeSortObjects = (d.typeSort || []).map(item => ({
						typeId: parseInt(item.typeId),
						pic1: item.pic1 || '',
						pic2: item.pic2 || '',
						pic3: item.pic3 || ''
					}));
					
					const yearCfg = {
						voteNum: d.voteNum,
						musicVoteNum: d.musicVoteNum,
						entrancePic:d.entrancePic,
						hideIds:d.hideIds,
						actStart: this.localToDateTimeStr(d.actStart),
						actEnd: this.localToDateTimeStr(d.actEnd),
						suduStartTime: this.localToDateTimeStr(d.suduStartTime),
						suduEndTime: this.localToDateTimeStr(d.suduEndTime),
						typeSort: typeSortObjects,
						stepConfig: (d.steps || []).map(s => {
							const step = {
								key: s.key,
								name: s.name,
								startTime: s.startTime ? this.localToDateTimeStr(s.startTime) : '',
								endTime: s.endTime ? this.localToDateTimeStr(s.endTime) : '',
								sortType: s.sortType
							};
							
							if (s.lineNumMap && Object.keys(s.lineNumMap).length) {
								const lineNumMap = {};
								for (const [k, v] of Object.entries(s.lineNumMap)) {
									if (k) lineNumMap[parseInt(k)] = v;
								}
								step.lineNumMap = lineNumMap;
							}
							
							if (s.winNumMap && Object.keys(s.winNumMap).length) {
								const winNumMap = {};
								for (const [k, v] of Object.entries(s.winNumMap)) {
									if (k) winNumMap[parseInt(k)] = v;
								}
								step.winNumMap = winNumMap;
							}
							
							return step;
						})
					};
					configMap[yr] = yearCfg;
				}
				return { configMap };
			},
			
			compareTime(time1, time2) {
			    if (!time1 || !time2) return true;
			    return new Date(time1) <= new Date(time2);
			},
			
			// 验证数据
			validateData() {
				const errors = [];
				for (let yr of this.yearList) {
					const d = this.yearData[yr];
					
					// 验证票夹活动时间
					if (!d.actStart) errors.push(`[${yr}] 票夹活动开始时间 (actStart) 必填`);
					if (!d.actEnd) errors.push(`[${yr}] 票夹活动结束时间 (actEnd) 必填`);
					
					// 榜单展示时间
					if (!d.suduStartTime) errors.push(`[${yr}] 榜单展示开始时间 (suduStartTime) 必填`);
					if (!d.suduEndTime) errors.push(`[${yr}] 榜单展示结束时间 (suduEndTime) 必填`);
					
					
					// 验证票夹活动结束时间不能早于开始时间
					if (d.actStart && d.actEnd) {
						const actStartStr = this.localToDateTimeStr(d.actStart);
						const actEndStr = this.localToDateTimeStr(d.actEnd);
						console.log('actStartStr:', actStartStr, 'actEndStr:', actEndStr);
						if (!this.compareTime(actStartStr, actEndStr)) {
							errors.push(`[${yr}] 票夹活动结束时间不能早于开始时间`);
						}
					}
					
					if (d.suduStartTime && d.suduEndTime) {
						const actStartStr = this.localToDateTimeStr(d.suduStartTime);
						const actEndStr = this.localToDateTimeStr(d.suduEndTime);
						console.log('actStartStr:', actStartStr, 'actEndStr:', actEndStr);
						if (!this.compareTime(actStartStr, actEndStr)) {
							errors.push(`[${yr}] 榜单展示结束时间不能早于开始时间`);
						}
					}
					
					if (d.steps && d.steps.length) {
						d.steps.forEach(s => {
							if (!s.startTime) errors.push(`[${yr}] ${s.name} - 阶段开始时间必填`);
							if (!s.endTime) errors.push(`[${yr}] ${s.name} - 阶段结束时间必填`);
							
							// 验证阶段结束时间不能早于开始时间
							if (s.startTime && s.endTime) {
								const startStr = this.localToDateTimeStr(s.startTime);
								const endStr = this.localToDateTimeStr(s.endTime);
								if (!this.compareTime(startStr, endStr)) {
									errors.push(`[${yr}] ${s.name} - 阶段结束时间不能早于开始时间`);
								}
							}
						});
					}
				}
				return errors;
			},
			
			// 提交配置
			submitConfig() {
				// 验证数据
				const errors = this.validateData();
				if (errors.length > 0) {
					this.$message.error(errors[0]);
					return;
				}
				
				const submitData = this.buildSubmitData();
				
				console.log('提交的 config 参数：', submitData);
				
				this.btnLoading = true;
				
				this.$request({
					url: '/lpa/updateConfig',
					method: 'POST',
					data: submitData, 
					
				})
				.then((res) => {
					const { state, msg } = res.data;
					if (state == 1) {
						this.$message.success('配置提交成功');
					} else {
						this.$message.error(msg || '请求失败');
					}
				})
				.catch(() => {
					this.$message.error('请求错误');
				})
				.finally(() => {
					this.btnLoading = false;
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.app-container {
		margin: 0 auto;
	}

	.header-card {
		margin-bottom: 20px;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		color: #fff;
	}

	.header-card .el-card__body {
		padding: 20px 24px;
	}

	.header-title {
		font-size: 22px;
		font-weight: 600;
		margin-bottom: 8px;
	}

	.header-desc {
		font-size: 13px;
		opacity: 0.85;
	}

	.config-card {
		margin-bottom: 20px;
	}

	.config-card .el-card__header {
		background: #fafbfc;
		border-bottom: 1px solid #e8eaed;
		padding: 12px 20px;
	}

	.config-card .el-card__header h3 {
		font-size: 16px;
		font-weight: 600;
		color: #2c3e50;
	}

	.year-tag {
		margin-right: 12px;
		margin-bottom: 12px;
		cursor: pointer;
	}

	.type-sort-container {
		border: 1px solid #e4e7ed;
		border-radius: 8px;
		padding: 12px;
		background: #fafafa;
		min-height: 200px;
	}

	.sortable-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 12px;
		margin-bottom: 6px;
		background: #fff;
		border: 1px solid #e4e7ed;
		border-radius: 6px;
		cursor: grab;
		transition: all 0.2s;
		user-select: none;
	}
	
	.sortable-item:active {
		cursor: grabbing;
	}

	.sortable-item:hover {
		border-color: #667eea;
		box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
	}

	.sortable-item .sort-index {
		width: 24px;
		height: 24px;
		border-radius: 50%;
		background: #667eea;
		color: #fff;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: 600;
		margin-right: 12px;
	}

	.sortable-item .sort-label {
		flex: 1;
		font-size: 14px;
	}

	.step-card {
		background: #fafbfc;
		border: 1px solid #e8eaed;
		border-radius: 8px;
		padding: 16px;
		margin-bottom: 16px;
	}

	.step-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 16px;
		padding-bottom: 12px;
		border-bottom: 1px dashed #e4e7ed;
	}

	.step-badge {
		display: inline-block;
		padding: 2px 12px;
		border-radius: 20px;
		font-size: 12px;
		font-weight: 500;
	}

	.step-badge-1 {
		background: #e6f7e6;
		color: #52c41a;
	}

	.step-badge-2 {
		background: #fff7e6;
		color: #fa8c16;
	}

	.step-badge-3 {
		background: #e6f4ff;
		color: #1890ff;
	}

	.map-row {
		display: flex;
		gap: 12px;
		align-items: center;
		margin-bottom: 12px;
		flex-wrap: wrap;
	}

	.map-row .el-select {
		width: 20%;
	}

	.map-row .el-input-number {
		width: 20%;
	}

	.del-btn {
		cursor: pointer;
		color: #f56c6c;
		font-size: 18px;
	}

	.del-btn:hover {
		color: #f23030;
	}

	.empty-tip {
		text-align: center;
		padding: 60px 0;
		color: #999;
	}

	.action-buttons {
		margin-top: 20px;
	}

	.form-item-tip {
		font-size: 12px;
		color: #909399;
		line-height: 1.5;
		margin-top: 4px;
	}
</style>